import React from 'react';
import clsx from 'clsx';
import classes from './LabeledText.module.css';
const LabeledText = ({ Tag = 'div', label, value, className, LabelTag = 'h3', ValueTag = 'p' }) => {
  return (
    <Tag className={clsx(classes.shortLabelWrapper, className)}>
      {label && <LabelTag className={classes.shortLabel}>{label}</LabelTag>}
      {value && <ValueTag className={classes.shortValue}>{value}</ValueTag>}
    </Tag>
  );
};

export default LabeledText;
